<template>
	<div class="d-flex align-items-center">
		<img v-if="!clean" :src="require(`@/assets/img/logo/${logo}`)" alt="MiChollo">
		<div class="air__utils__logo__text" :class="{'ml-0': clean}">
			<div class="air__utils__logo__name text-uppercase font-size-21" :class="'text-'+color">
				MiChollo
			</div>
			<div class="air__utils__logo__descr text-uppercase font-size-12 text-gray-6">
				Administración
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Logo',
	props: {
		logo: {
			type: String,
			default: 'logo.png',
		},
		color: {
			type: String,
			default: 'dark',
		},
		clean: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
